"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMaterialTypography = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const PREFIX = "Typography";
exports.classes = {
    body3: `${PREFIX}-body3`,
    darkBg: `${PREFIX}-darkBg`,
    underline: `${PREFIX}-underline`,
    h1NoClamp: `${PREFIX}-h1NoClamp`,
    h2NoClamp: `${PREFIX}-h2NoClamp`,
    h3NoClamp: `${PREFIX}-h3NoClamp`,
    h4NoClamp: `${PREFIX}-h4NoClamp`
};
const getH1UnderlineStyles = (theme) => ({
    height: "5px",
    width: "100px",
    marginTop: "12px",
    [theme.breakpoints.down(1024)]: {
        height: "4px",
        width: "90px"
    }
});
const h2UnderlineStyles = {
    marginTop: "6px",
    height: "4px",
    width: "90px"
};
const getH3UnderlineStyles = (theme) => ({
    height: "4px",
    width: "90px",
    marginTop: "6px",
    [theme.breakpoints.down(1024)]: {
        height: "3px",
        width: "80px"
    }
});
const h4UnderlineStyles = {
    marginTop: "6px",
    height: "3px",
    width: "80px"
};
exports.StyledMaterialTypography = (0, styles_1.styled)(Typography_1.default)(({ theme, variant }) => ({
    [`&.${exports.classes.body3}`]: {
        fontSize: "0.668rem"
    },
    [`&.${exports.classes.underline}`]: {
        [`&::after`]: {
            backgroundColor: theme.colours.accent,
            content: '""',
            display: "block",
            marginBottom: "24px",
            ...(variant === "h1"
                ? getH1UnderlineStyles(theme)
                : variant === "h2"
                    ? h2UnderlineStyles
                    : variant === "h3"
                        ? getH3UnderlineStyles(theme)
                        : variant === "h4"
                            ? h4UnderlineStyles
                            : { height: "4px", width: "100px", marginTop: "1rem" })
        },
        [`&.${exports.classes.darkBg}`]: {
            "&::after": {
                backgroundColor: theme.colours.accent300
            }
        }
    },
    [`&.${exports.classes.h1NoClamp}`]: {
        fontSize: "3rem"
    },
    [`&.${exports.classes.h2NoClamp}`]: {
        fontSize: "2.5rem"
    },
    [`&.${exports.classes.h3NoClamp}`]: {
        fontSize: "2rem"
    },
    [`&.${exports.classes.h4NoClamp}`]: {
        fontSize: "1.25rem"
    }
}));
//# sourceMappingURL=data:application/json;base64,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